// Copyright 2019-2020 @polkadot/wasm-crypto authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/wasm-crypto/wasm_asm_stub.js
// module id = 453
// module chunks = 0